export const SHOP_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending',
  SUSPENDED: 'suspended',
};
